import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true,

  },
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  // {
  //   path: '',
  //   component: Layout,
  //   redirect: '/',
  //   children: [
  //     {
  //       path: '',
  //       name: 'home',
  //       component: () => import('@/views/home/index'),
  //       meta: {title: '首页', icon: 'product-list'}
  //     },
  //
  //   ]
  // }
]
export const asyncRouterMap = [
  //网站管理以及商品分类
  {
    id: 11000,
    path:'/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '权限', icon: 'ums'},
    children: [
      {
        id: 11100,
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        id: 11200,
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/roles/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/roles/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
    ]
  },
  {
    id: 12000,
    path:'/mail',
    component: Layout,
    redirect: '/mail/mailbox',
    name: 'mail',
    meta: {title: '邮箱', icon: 'product-cate'},
    children: [
      {
        id: 12100,
        path: 'mailbox',
        name: 'mailbox',
        component: () => import('@/views/mail/mailbox/index'),
        meta: {title: '邮箱管理', icon: 'product-cate'}
      },
      {
        id: 12200,
        path: 'mailb',
        name: 'mailb',
        component: () => import('@/views/mail/mailb/index'),
        meta: {title: '邮件管理', icon: 'product-cate'}
      },
      {
        id: 12300,
        path: 'blacklist',
        name: 'blacklist',
        component: () => import('@/views/mail/blacklist/index'),
        meta: {title: '黑名单', icon: 'product-cate'}
      },
      {
        id: 12400,
        path: 'log',
        name: 'log',
        component: () => import('@/views/mail/log/index'),
        meta: {title: '操作日志', icon: 'product-cate'}
      },
      {
        id: 12500,
        path: 'stat',
        name: 'stat',
        component: () => import('@/views/mail/stat/index'),
        meta: {title: '邮件统计', icon: 'product-cate'}
      },


    ]
  },
  {
    id: 13000,
    path:'/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: {title: '订单', icon: 'oms'},
    children: [
      {
        id: 13100,
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/order/index'),
        meta: {title: '订单管理', icon: 'query'}
      },
      {

        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/orderDetail'),
        meta: {title: '订单详情'},
        hidden:true
      },

    ]
  },


  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js